<ap-section-header>
  <ap-section-header-grid
    [iconId]="'ap-basedata-icon'"
    [caption]="'Settings__Lbl_Menu_Resources'"
    [filterPlaceholder]="'Global_Filter'"
    [filterTooltip]="'Settings__Lbl_Menu_Resources'"
    [createText]="'Global__New'"
    [canSearch]="true"
    (search)="searchIn($event)"
    (createDataset)="createNew()"
    [canCreate]="isCreateNewAllowed()">
  </ap-section-header-grid>
</ap-section-header>


<div class="ap-tabstrip-small">
<kendo-tabstrip (tabSelect)="selectTab($event)" id="ressourcesTabStrip">
  <kendo-tabstrip-tab [selected]="true">
    <ng-template kendoTabTitle>
      <ap-responsive-text key="Docu_Ini__Engines" class="ap-tabstrip-header"></ap-responsive-text>
    </ng-template>
    <ng-template kendoTabContent>
      <ap-machines-overview></ap-machines-overview>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab>
    <ng-template kendoTabTitle>
      <ap-responsive-text key="gadget" class="ap-tabstrip-header"></ap-responsive-text>
    </ng-template>
    <ng-template kendoTabContent>
      <ap-instruments-overview></ap-instruments-overview>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab>
    <ng-template kendoTabTitle>
      <ap-responsive-text text="{{'Docu_Ini__Workers' | translate}} / {{'Docu_Ini__Motorist' | translate}}" class="ap-tabstrip-header"></ap-responsive-text>
    </ng-template>
    <ng-template kendoTabContent>
      <ap-drivers-overview></ap-drivers-overview>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab>
    <ng-template kendoTabTitle>
      <ap-responsive-text key="Global_Terminals" class="ap-tabstrip-header"></ap-responsive-text>
    </ng-template>
    <ng-template kendoTabContent>
      <ap-terminals-overview></ap-terminals-overview>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
</div>
